<header class="col-12 header-page">
    <h1 class="col-sm-12 col-md-7 col-xl-7 px-1 header__page__content__title">
        Reembolso
    </h1>
    <div class="col-sm-12 col-md-5 col-xl-5 px-1">
        <a type="button" [routerLink]="['/minhas-solicitacoes-reembolso']"
            class="btn btn-outline-primary btn-outline-primary-historico float-right">
            <span>Minhas Solicitações</span>
        </a>
    </div>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="col-sm-12 col-xl-12 main__content" *ngIf="refundTypeList && refundTypeList.length > 0 else showLoading">
    <section>
        <!-- <h4>Critérios para solicitação de reembolso</h4> -->
        <blockquote class="mt-2 main-content-blockquote">
            Conforme Regulamento do ProSaude II e III, capitulo XII, Art 80°, inciso 3°, "A efetivação do reembolso está
            condicionada à apresentação completa dos documentos necessários...", desta forma os dados do profissional
            executante (nome, Conselho Profissional, CPF) quando se tratar de recibo e (nome, conselho profissional)
            quando se tratar de Nota Fiscal, são informações indispensáveis para que o reembolso seja creditado. Além
            disso, a Fundação Copel tem a obrigação de enviar para ANS todos os dados de reembolso das despesas
            assistenciais realizadas pelos beneficiários, de acordo com A RN 501 - Padrão TISS (Troca de Informações na
            Saúde Suplementar), capítulo I, Art. 5°, inciso 2°.
            <br>
            <b class="main-content-blockquote-aviso">
                Para solicitar reembolso, o beneficiário deverá encaminhar os documentos necessários (nota fiscal,
                pedido médico, entre outros) no prazo máximo de
                um ano a contar da data da realização do evento ou da alta hospitalar.
            </b>
        </blockquote>
    </section>
    <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formData"
        (ngSubmit)="saveSolicitation()">
        <section class="content-form">
            <div class="col-xl-4 mb-2 px-1">
                <label class="content__form__title__label">Tipo de Reembolso <span class="label__form__required">
                        *</span> </label>
                <ng-select [clearable]="false" [items]="refundTypeList" (change)="tipoReembolsoSelecionado($event)" [searchable]="false"
                    (open)="resetForm()" bindLabel="description" bindValue="id" inputmode='none'
                    [searchable]="false"  
                    placeholder="Selecione um tipo de reembolso" formControlName="refundTypeId">
                </ng-select>
                <small class="form-text text-muted danger "
                    *ngIf="formData.get('refundTypeId')?.touched && formData.get('refundTypeId')?.invalid" [@fadeIn]>
                    Por favor, selecione um Tipo de Reembolso!
                </small>
            </div>
        </section>
        <aviso *ngIf="formData.get('refundTypeId')?.value == refundTypes.CONSULTA">
            O tipo de reembolso consulta é permitido somente para: consultas médicas eletivas e/ou emergência realizada
            por um profissional cujo conselho profissional seja CRM – conselho regional de medicina. Para consulta com
            dentistas selecionar a opção. (Odontologia), demais consultas selecionar a opção "Terapias".
        </aviso>
        <!-- 
              <br>
                <h3 *ngIf="formData.get('refundTypeId')?.valid" [@fadeIn]>Formulário de reembolso</h3>             -->
        <br>
        <section class="content-form content-form-reembolso mt-0" *ngIf="formData.get('refundTypeId')?.valid" [@fadeIn]>
            <div class="mt-2">
                <h4 class="mt-0">Beneficiário</h4>
                <section class="row px-2">
                    <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1"
                        *ngIf="personate && formData.get('refundTypeId')?.touched && formData.get('refundTypeId')?.valid">
                        <label class="label-form">Data da Solicitação <span class="label__form__required">*</span>
                        </label>
                        <input type="datetime-local" class="form-control input-form" formControlName="requestDate">
                    </div>
                    <div class="col-xl-4 col-md-6 col-sm-12 mt-3 px-1">
                        <label class="content__form__title__label">Beneficiário <span
                                class="label__form__required">*</span></label>
                        <ng-select [clearable]="false" [searchable]="false"  [items]="beneficiaries" inputmode="none" [clearable]="false"
                            (change)="beneficiarioSelecionado($event)" bindLabel="name" bindValue="id"
                            placeholder="Selecione um beneficiário" formControlName="beneficiaryId">
                        </ng-select>
                        <small class="form-text text-muted danger "
                            *ngIf="formData.get('beneficiaryId')?.touched && formData.get('beneficiaryId')?.invalid"
                            [@fadeIn]>
                            Por favor, selecione um beneficiário
                        </small>
                    </div>
                </section>
            </div>
            <section class="content-before-beneficiario" *ngIf="this.formData.get('beneficiaryId')?.value" [@fadeIn]>
                <div class="mt-3"
                    *ngIf="
                        (formData.get('refundTypeId')?.value === refundTypes.CONSULTA || formData.get('refundTypeId')?.value === refundTypes.INSTRUMENTACAO_CIRURGICA 
                        || formData.get('refundTypeId')?.value === refundTypes.ODONTOLOGIA || formData.get('refundTypeId')?.value === refundTypes.TERAPIAS
                        || formData.get('refundTypeId')?.value === refundTypes.EXAMES || formData.get('refundTypeId')?.value === refundTypes.HONORARIOS_MEDICOS)">
                    <h4>Documento</h4>
                    <section class="row px-1">
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="content__form__title__label">Tipo de documento <span
                                    class="label__form__required"> *</span></label>
                            <ng-select [clearable]="false" [items]="selectDocumentTypeList" [searchable]="false" inputmode="none" [clearable]="false"
                                (close)="tipoDocumentoSelecionado($event)" bindLabel="description" bindValue="id"
                                placeholder="Selecione" formControlName="documentTypeId">
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('documentTypeId')?.touched && formData.get('documentTypeId')?.invalid"
                                [@fadeIn]>
                                Por favor, selecione um tipo de documento!
                            </small>
                        </div>
                    </section>
                    <section class="row px-1"
                        *ngIf="formData.get('documentTypeId')?.value === tipoDocumento.NOTA_FISCAL" [@fadeIn]>
                        <section class="col-xl-11 row px-0" formGroupName="financialInvoice">
                            <div class="col-xl-1 col-md-6 col-sm-12 mt-2 px-1">
                                <label class="content__form__title__label">N° Nota <span
                                    class="label__form__required"> *</span></label>
                                <input class="form-control input-form" mask="000.000" formControlName="number">
                                <small class="form-text text-muted danger "
                                    *ngIf="formData.get('financialInvoice.number')?.touched && formData.get('financialInvoice.number')?.invalid"
                                    [@fadeIn]>
                                    Por favor, informe o número da nota!
                                </small>
                            </div>
                            <div class="col-xl-2 col-md-6 col-sm-12 mt-2 px-1">
                                <label class="content__form__title__label">Data de emissão<span
                                        class="label__form__required"> *</span></label>
                                <input type="date" class="form-control input-form" formControlName="issueDate"
                                    min="{{dataContratacao}}" max="{{today | date:'yyyy-MM-dd'}}"
                                    (change)="dataChanged('financialInvoice')" />
                                <small class="form-text text-muted danger "
                                    *ngIf="formData.get('financialInvoice.issueDate')?.touched && formData.get('financialInvoice.issueDate')?.invalid"
                                    [@fadeIn]>
                                    Por favor, selecione uma Data de Emissão!
                                </small>
                            </div>
                            <div class="col-xl-2 col-md-6 col-sm-12 mt-2 px-1">
                                <label class="content__form__title__label">Data de realização<span
                                        class="label__form__required"> *</span></label>
                                <input type="date" class="form-control input-form" formControlName="executionDate"
                                    min="{{dataContratacao}}"
                                    [max]="formData.get('financialInvoice.issueDate')?.value" />
                                <small class="form-text text-muted danger"
                                    *ngIf="formData.get('financialInvoice.executionDate')?.touched && formData.get('financialInvoice.executionDate')?.hasError('required') && !formData.controls.financialInvoice.controls.executionDate.hasError('invalidData')"
                                    [@fadeIn]>
                                    Por favor, insira uma data válida
                                </small>
                                <small class="form-text text-muted danger"
                                    *ngIf="formData.controls.financialInvoice.controls.executionDate.hasError('invalidData') && formData.get('financialInvoice.executionDate')?.dirty"
                                    [@fadeIn]>
                                    Excedido prazo para reembolso.
                                </small>
                            </div>
                            <div class="col-xl-2 col-md-6 col-sm-12 mt-2 px-1">
                                <label class="content__form__title__label">CNPJ <span class="label__form__required"> *</span></label>
                                <input class="form-control input-form" placeholder="__.___.___/____-__"
                                    [mask]="'00.000.000/0000-00'" formControlName="cnpj">
                                <small class="form-text text-muted danger "
                                    *ngIf="formData.get('financialInvoice.cnpj')?.touched && formData.get('financialInvoice.cnpj')?.invalid"
                                    [@fadeIn]>
                                    Por favor, informe um CNPJ válido!
                                </small>
                            </div>
                            <div class="col-xl-5 col-md-6 col-sm-12 px-1">
                                <form-input
                                [errorRequired]="(formData.get('financialInvoice.file')?.touched && formData.get('financialInvoice.file')?.value == null)"
                                [labelInput]="'Upload da Nota Fiscal '" 
                                [isMultiple]="false"
                                [isRequired]="true"
                                [tipoDocumento]="'financialInvoice'"
                                [labelClass]="'content__form__title__label'"
                                (adicionar)="adicionarArquivos('financialInvoice',$event)">
                            </form-input>

                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formData.get('financialInvoice.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFile('financialInvoice',i)" [icon]="faSquareXmark">
                                            </fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>
                        <div class="col-xl-1 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="content__form__title__label">Valor <span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="R$ 0,00"
                                formControlName="requestedValue" maxlength="14"
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('requestedValue')?.touched && formData.get('requestedValue')?.invalid"
                                [@fadeIn]>
                                Por favor, insira um valor válido
                            </small>
                        </div>
                    </section>
                    <section class="row px-1" *ngIf="formData.get('documentTypeId')?.value === tipoDocumento.RECIBO"
                        [@fadeIn]>
                        <section class="row col-10 px-0" formGroupName="financialReceipt">
                            <div class="col-xl-2 col-md-6 col-sm-12 mt-2 pt-2 px-1">
                                <label class="content__form__title__label">Data de Emissão <span
                                        class="label__form__required"> *</span></label>
                                <input type="date" class="form-control input-form" formControlName="issueDate"
                                    min="{{dataContratacao}}" max="{{today | date:'yyyy-MM-dd'}}"
                                    (change)="dataChanged('financialReceipt')" />
                                <small class="form-text text-muted danger "
                                    *ngIf="formData.get('financialReceipt.issueDate')?.touched && formData.get('financialReceipt.issueDate')?.invalid"
                                    [@fadeIn]>
                                    Por favor, selecione uma Data de Emissão!
                                </small>
                            </div>
                            <div class="col-xl-2 col-md-6 col-sm-12 mt-2 pt-2 px-1">
                                <label class="content__form__title__label">Data de Realização <span
                                        class="label__form__required"> *</span></label>
                                <input type="date" class="form-control input-form" formControlName="executionDate"
                                    min="{{dataContratacao}}" [max]="formData.get('financialReceipt.issueDate')?.value"
                                    [disabled]="true" />
                                <small class="form-text text-muted danger"
                                    *ngIf="formData.get('financialReceipt.executionDate')?.touched && formData.get('financialReceipt.executionDate')?.hasError('required') && !formData.controls.financialReceipt.controls.executionDate.hasError('invalidData')"
                                    [@fadeIn]>
                                    Por favor, insira uma data válida
                                </small>
                                <small class="form-text text-muted danger"
                                    *ngIf="formData.controls.financialReceipt.controls.executionDate.hasError('invalidData') && formData.get('financialReceipt.executionDate')?.dirty"
                                    [@fadeIn]>
                                    Excedido prazo para reembolso.
                                </small>
                            </div>
                            <div class="col-xl-8 col-md-6 col-sm-12 px-1">
                                <form-input
                                    [errorRequired]="(formData.get('financialReceipt.file')?.touched && formData.get('financialReceipt.file')?.value == null)"
                                    [formFiles]="formData.get('financialReceipt.file')?.value" [isRequired]="true"
                                    [labelInput]="'Upload do Recibo '" [isMultiple]="false"
                                    [tipoDocumento]="'financialReceipt'"
                                    (adicionar)="adicionarArquivos('financialReceipt',$event)">
                                </form-input>
                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formData.get('financialReceipt.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{ itemFile.fileName }} - ({{ itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFile('financialReceipt', i)"
                                                [icon]="faSquareXmark"></fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>
                        <div class="col-xl-2 col-md-6 col-sm-12 mt-2 pt-1 px-1">
                            <label class="content__form__title__label">Valor <span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="R$ 0,00"
                                formControlName="requestedValue" maxlength="14"
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('requestedValue')?.touched && formData.get('requestedValue')?.invalid"
                                [@fadeIn]>
                                Por favor, insira um valor válido
                            </small>
                        </div>
                    </section>
                </div>
                <div class="mt-3" *ngIf="formData.get('refundTypeId')?.value === refundTypes.MEDICAMENTO">
                    <h4>Documento(s)</h4>
                    <!-- <p class="mt-2 px-2">Nota Fiscal</p> -->
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input
                                [errorRequired]="(formData.get('financialInvoiceMedical.file')?.touched && formData.get('financialInvoiceMedical.file')?.value == null)"
                                [isRequired]="true" [labelInput]="'Upload da Nota Fiscal '" [isMultiple]="false"
                                [tipoDocumento]="'financialInvoiceMedical'"
                                (adicionar)="adicionarArquivos('financialInvoiceMedical',$event)">
                            </form-input>
                            <section class="content-form-lista" [@fadeIn]>
                                <div class="lista-row"
                                    *ngFor="let itemFile of formData.get('financialInvoiceMedical.file')?.value; let i = index"
                                    [@fadeIn]>
                                    <span>
                                        {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                    </span>
                                    <div class="lista-actions">
                                        <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                            (click)="removeFile('financialInvoiceMedical',i)"
                                            [icon]="faSquareXmark"></fa-icon>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input
                                [errorRequired]="(formData.get('medicalReceipt.file')?.touched && formData.get('medicalReceipt.file')?.value == null)"
                                (adicionar)="adicionarArquivos('medicalReceipt',$event)" [isRequired]="true"
                                [isMultiple]="false" [labelInput]="'Upload da Receita '"
                                [tipoDocumento]="'medicalReceipt'">
                            </form-input>
                            <section class="content-form-lista" [@fadeIn]>
                                <div class="lista-row"
                                    *ngFor="let itemFile of formData.get('medicalReceipt.file')?.value; let i = index"
                                    [@fadeIn]>
                                    <span>
                                        {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                    </span>
                                    <div class="lista-actions">
                                        <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                            (click)="removeFile('medicalReceipt',i)" [icon]="faSquareXmark">
                                        </fa-icon>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-12 mt-2 pt-1 px-1">
                            <label class="content__form__title__label">Valor <span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="R$ 0,00"
                                formControlName="requestedValue" maxlength="14"
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('requestedValue')?.touched && formData.get('requestedValue')?.invalid"
                                [@fadeIn]>
                                Por favor, insira um valor válido
                            </small>
                        </div>
                    </section>
                </div>
                <div class="mt-3"
                    *ngIf="formData.get('refundTypeId')?.value !== refundTypes.MEDICAMENTO && formData.get('documentTypeId')?.value">
                    <h4>Dados do Profissional Executante </h4>
                    <section class="row px-2" formGroupName="executor">
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1 convenantForm">
                            <label class="content__form__title__label">Nome do Profissional Executante <span class="label__form__required">*</span> </label>
                            <ng-select [clearable]="false"  [typeToSearchText]="''" 
                                (change)="tipoConcelhoSelecionado($event, 'profissionalExecutante')"
                                (keydown)="validarCampos($event, 'profissionalExecutante')"
                                (search)="customSearchNomeFn($event)" formControlName="profissionalExecutante"
                                placeholder="Informe o nome do profissional" notFoundText="Nenhum valor encontrado"
                                [typeahead]="seuTypeahead">
                                <ng-option *ngFor="let item of listaCRM;" [value]="item" (click)="fecharNome($event)">
                                    {{item.nome}}
                                </ng-option>
                            </ng-select>
                            <small class="form-text text-muted danger "
                            *ngIf="formData.get('executor.profissionalExecutante')?.touched && formData.get('executor.profissionalExecutante')?.invalid"
                            [@fadeIn]>
                            Por favor, informe o nome do profissional!
                        </small>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-12 px-1 convenantForm conselho">
                            <label class="content__form__title__label">Nº do Conselho <span class="label__form__required">
                                    *</span></label>
                            <ng-select [clearable]="false" [typeToSearchText]="''"
                            [clearable]="false"
                                (change)="tipoConcelhoSelecionado($event, 'councilNumber')"
                                (keydown)="validarCampos($event, 'conselho')" (search)="customSearchFn($event)"
                                formControlName="councilNumber" notFoundText="Nenhum valor encontrado"
                                [typeahead]="seuTypeahead">
                                <ng-option *ngFor="let item of listaCRM" [value]="item" (click)="crmSelected($event)">
                                    {{item.conselho}} - {{item.nome}}
                                </ng-option>
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('executor.councilNumber')?.touched && formData.get('executor.councilNumber')?.invalid"
                                [@fadeIn]>
                                Por favor, informe o número do conselho!
                            </small>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="content__form__title__label">Conselho <span class="label__form__required">
                                    *</span></label>
                            <ng-select [clearable]="true" [searchable]="false" [items]="councils" (change)="councilChanged($event)"
                                bindLabel="name" bindValue="id" formControlName="councilId"
                                [clearable]="false"
                                placeholder="Selecione um conselho">
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('executor.councilId')?.touched && formData.get('executor.councilId')?.invalid"
                                [@fadeIn]>
                                Por favor, selecione um conselho!
                            </small>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 mt-2 px-1">
                            <label class="content__form__title__label">UF Conselho</label>
                            <ng-select formControlName="uf"  [items]="ufs" [searchable]="false" [clearable]="true"
                            [clearable]="false"
                                placeholder="Selecione">
                                <ng-template ng-label-tmp let-item="item">
                                    {{ item }}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-12 mt-1 px-1"
                            *ngIf="formData.get('documentTypeId')?.value != tipoDocumento.NOTA_FISCAL">
                            <label class="label-form">CPF do Profissional <span
                                    class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="___.___.___-__" mask="000.000.000-00"
                                formControlName="cpf" (input)="validaCpf()">
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('executor.cpf')?.touched && formData.get('executor.cpf')?.invalid"
                                [@fadeIn]>
                                Por favor, informe um CPF válido!
                            </small>
                        </div>
                    </section>
                </div>
                <div class="mt-3" *ngIf="formData.get('refundTypeId')?.value === refundTypes.INSTRUMENTACAO_CIRURGICA 
                            || formData.get('refundTypeId')?.value === refundTypes.TERAPIAS
                            || formData.get('refundTypeId')?.value === refundTypes.EXAMES
                            || formData.get('refundTypeId')?.value === refundTypes.HONORARIOS_MEDICOS">
                    <h4>Guia de Autorização</h4>
                    <section class="px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1" formGroupName="medicalGuide">
                            <label class="content__form__title__label">Guia de Autorização <span
                                    class="label__form__required">*</span></label>
                            <ng-select [clearable]="false" [searchable]="false" [items]="refundableGuides"
                                (change)="guiaAutorizacaoAlterada($event)" bindLabel="guideInfo" bindValue="code"
                                placeholder="Selecione uma guia" formControlName="number"
                                notFoundText="Não há guias para este beneficiário">
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('medicalGuide.number')?.touched && formData.get('medicalGuide.number')?.invalid"
                                [@fadeIn]>
                                Por favor, selecione ao menos uma guia
                            </small>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1"
                            *ngIf="( formData.get('medicalGuide.number')?.value != null && formData.get('refundTypeId')?.value == refundTypes.HONORARIOS_MEDICOS ) 
                                    || ( formData.get('medicalGuide.number')?.value != null && formData.get('refundTypeId')?.value ==  refundTypes.INSTRUMENTACAO_CIRURGICA )"
                            [@fadeIn]>
                            <label class="content__form__title__label">Procedimentos realizados</label>
                            <div class="guia-card-content procedimentos-realizados-card"
                                *ngFor="let procedure of procedures; let lastItem = last" [@fadeIn]>
                                <h5>{{procedure.code}}</h5>
                                <p>
                                    {{procedure.description}}
                                </p>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 col-sm-12 mt-2 px-1"
                            *ngIf="(formData.get('medicalGuide.number')?.value != null && formData.get('refundTypeId')?.value == refundTypes.TERAPIAS)"
                            [@fadeIn]>
                            <label class="content__form__title__label">Procedimentos realizados</label>
                            <section class="content-procedimentos">
                                <div class="guia-card-content procedimentos-realizados-card"
                                    *ngFor="let procedure of procedures; let indexItem = index" [@fadeIn]>
                                    <h5 [@fadeIn]>{{procedure.code}}</h5>
                                    <p class="realizados-card-descricao" [@fadeIn]>
                                        {{procedure.description}}
                                    </p>
                                    <section class="procedimentos-sessoes" [@fadeIn]>
                                        <div *ngFor="let sessao of procedure.sessions">
                                            <div [attr.id]="sessao.id" [@fadeIn]>
                                                <label>Sessão {{sessao.id}} <span
                                                        class="label__form__required">*</span></label>
                                                <input type="date" class="form-control input-form"
                                                    min="{{lastYear | date:'yyyy-MM-dd'}}"
                                                    max="{{today | date:'yyyy-MM-dd'}}"
                                                    (change)="sessionDataChanged(procedure.code, sessao, $event, indexItem)"
                                                    (blur)="sessionDataChanged(procedure.code, sessao, $event, indexItem)"
                                                    *ngIf="!sessao.notDone" [@fadeIn] />
                                                <small class="form-text text-muted danger d-none"
                                                    [id]="'warningSession_'+ indexItem + '_' + sessao.id" [@fadeIn]>
                                                    Por favor, insira uma data válida
                                                </small>
                                            </div>
                                            <div class="form-check" *ngIf="!sessao.date" [@fadeIn]>
                                                <input type="checkbox" class="form-check-input"
                                                    [id]="procedure.code + sessao.id"
                                                    (change)="sessionCheckChanged(procedure.code, sessao, $event, indexItem)">
                                                <label class="form-check-label" [for]="procedure.code + sessao.id">Não
                                                    realizei</label>
                                            </div>
                                        </div>
                                    </section>
                                    <small class="form-text text-muted text-muted-sessao danger"
                                        *ngIf="sessionErrorMessage" [id]="'warningProcedure_'+ procedure.code"
                                        [@fadeIn]>
                                        {{sessionErrorMessage}}
                                    </small>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1"
                            *ngIf="formData.get('medicalGuide.number')?.value != null && formData.get('refundTypeId')?.value == refundTypes.HONORARIOS_MEDICOS">
                            <label class="content__form__title__label">Grau de participação <span
                                    class="label__form__required">*</span></label>
                            <ng-select [clearable]="false" [searchable]="false" [items]="participationDregrees"
                                (change)="participationDegreeChanged($event)" formControlName="participationDegreeId"
                                bindLabel="description" bindValue="id" placeholder="Selecione uma guia">
                            </ng-select>
                        </div>
                    </section>
                    <h5 class="title-procedimentos"
                        *ngIf="formData.get('refundTypeId')?.value == refundTypes.EXAMES && formData.get('procedures')?.value"
                        [@fadeIn]>Procedimentos realizados</h5>
                    <section class="guia-content px-2"
                        *ngIf="formData.get('refundTypeId')?.value == refundTypes.EXAMES && formData.get('procedures')?.value"
                        [@fadeIn]>
                        <div class="guia-card"
                            *ngFor="let procedure of procedures; let lastItem = last; let indexItem = index">
                            <section class="guia-card-content">
                                <h5>{{procedure.code}}</h5>
                                <div>
                                    <span class="guia-card-title">Procedimento:</span>
                                    <span>{{procedure.description}}</span>
                                </div>
                                <div>
                                    <span class="guia-card-title">Quantidade:</span>
                                    <span>{{procedure.quantity}}</span>
                                </div>
                            </section>
                            <div class="px-0 content-form-procedimento">
                                <label class="label-form">Valor Total:<span class="label__form__required">
                                        *</span></label>
                                <input [id]="procedure.code" class="form-control input-form" placeholder="R$ XX,XX"
                                    maxlength="11" currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowZero:false, allowNegative:false }"
                                    formControlName="procedureValueNotUsed"
                                    (ngModelChange)="procedureValueChanged(procedure.code, $event,indexItem)">
                            </div>
                            <span class="text-center form-text text-muted danger" *ngIf="divergentValues" [@fadeIn]>
                                A soma dos valores dos procedimentos diverge do valor do documento fiscal.
                            </span>
                        </div>
                    </section>
                    <section class="row px-2" *ngIf="formData.get('refundTypeId')?.value == refundTypes.EXAMES">
                        <p class="mt-2 px-1 label-exame-guia">
                            Valor total dos procedimentos: <span> {{ totalProceduresValue | currency:'BRL' }}</span>
                        </p>
                    </section>
                </div>
                <div class="mt-3" *ngIf="formData.get('refundTypeId')?.value === refundTypes.ODONTOLOGIA">
                    <h4>Ficha Odontológica - FOA</h4>
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input
                                [errorRequired]="(formData.get('odontoDescription.file')?.touched && formData.get('odontoDescription.file')?.value == null)"
                                (adicionar)="adicionarArquivos('odontoDescription',$event)" [isRequired]="true"
                                [isMultiple]="true" [labelInput]="'Upload da Ficha '"
                                [tipoDocumento]="'odontoDescription'">
                            </form-input>
                        </div>
                        <section class="col-xl-12 p-0 content-form-lista" [@fadeIn]>
                            <div class="lista-row mx-1"
                                *ngFor="let itemFile of formData.get('odontoDescription.file')?.value; let i = index"
                                [@fadeIn]>
                                <span>
                                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile('odontoDescription',i)" [icon]="faSquareXmark"></fa-icon>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
                <div class="mt-3"
                    *ngIf="formData.get('procedures')?.value != null && documentRequired(24) || formData.get('refundTypeId')?.value === refundTypes.INSTRUMENTACAO_CIRURGICA">
                    <h4>Descrição Cirúrgica</h4>
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input
                                [errorRequired]="(formData.get('cirurgicalDescription.file')?.touched && formData.get('cirurgicalDescription.file')?.value == null)"
                                [labelInput]="'Upload da Descrição '" [isRequired]="true" [isMultiple]="false"
                                [tipoDocumento]="'cirurgicalDescription'"
                                (adicionar)="adicionarArquivos('cirurgicalDescription',$event)">
                            </form-input>
                        </div>
                        <section class="col-xl-12 p-0 content-form-lista" [@fadeIn]>
                            <div class="lista-row mx-1"
                                *ngFor="let itemFile of formData.get('cirurgicalDescription.file')?.value; let i = index"
                                [@fadeIn]>
                                <span>
                                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile('cirurgicalDescription',i)"
                                        [icon]="faSquareXmark"></fa-icon>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
                <div class="mt-3" *ngIf="formData.get('refundTypeId')?.value === refundTypes.INSTRUMENTACAO_CIRURGICA
                            || formData.get('refundTypeId')?.value === refundTypes.HONORARIOS_MEDICOS">
                    <h4>Laudo Anatomopatológico</h4>
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input [labelInput]="'Upload do Laudo Anatomopatológico '" [isRequired]="false"
                                [isMultiple]="false" [tipoDocumento]="'anatomopathologicalReport'"
                                (adicionar)="adicionarArquivos('anatomopathologicalReport',$event)">
                            </form-input>
                        </div>
                        <section class="col-xl-12 p-0 content-form-lista" [@fadeIn]>
                            <div class="lista-row mx-1"
                                *ngFor="let itemFile of formData.get('anatomopathologicalReport.file')?.value; let i = index"
                                [@fadeIn]>
                                <span>
                                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile('anatomopathologicalReport',i)" [icon]="faSquareXmark">
                                    </fa-icon>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
                <div class="mt-3" *ngIf="formData.get('anestheticRecord.name')?.enabled" [@fadeIn]>
                    <h4>Ficha Anestésica</h4>
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input [labelInput]="'Upload da Ficha '" [isRequired]="true" [isMultiple]="false"
                                [tipoDocumento]="'anestheticRecord'"
                                (adicionar)="adicionarArquivos('anestheticRecord',$event)">
                            </form-input>
                        </div>
                        <section class="col-xl-12 p-0 content-form-lista" [@fadeIn]>
                            <div class="lista-row mx-1"
                                *ngFor="let itemFile of formData.get('anestheticRecord.file')?.value; let i = index"
                                [@fadeIn]>
                                <span>
                                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile('anestheticRecord',i)" [icon]="faSquareXmark">
                                    </fa-icon>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
                <div class="mt-3"
                    *ngIf="formData.get('refundTypeId')?.value === refundTypes.TERAPIAS || formData.get('procedures')?.value && formData.controls.procedures.value.length > 0  && documentRequired(25)">
                    <h4>Pedido Médico</h4>
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input
                                [errorRequired]="(formData.get('medicalOrder.file')?.touched && formData.get('medicalOrder.file')?.value == null)"
                                [isRequired]="true" [isMultiple]="false" [labelInput]="'Upload do Pedido '"
                                [tipoDocumento]="'medicalOrder'" (adicionar)="adicionarArquivos('medicalOrder',$event)">
                            </form-input>
                        </div>
                        <section class="col-xl-12 p-0 content-form-lista" [@fadeIn]>
                            <div class="lista-row mx-1"
                                *ngFor="let itemFile of formData.get('medicalOrder.file')?.value; let i = index"
                                [@fadeIn]>
                                <span>
                                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile('medicalOrder',i)" [icon]="faSquareXmark"></fa-icon>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
                <div class="mt-3"
                    *ngIf="formData.get('refundTypeId')?.value && formData.get('documentTypeId')?.value !== tipoDocumento.CONSULTA">
                    <h4>Outros arquivos</h4>
                    <section class="row px-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 px-1">
                            <form-input [labelInput]="'Arquivos '" [isRequired]="false" [tipoDocumento]="'arquivos'"
                                [formFiles]="formData.get('otherFiles.file')?.value"
                                (adicionar)="adicionarArquivos('otherFiles',$event)">
                            </form-input>
                        </div>
                    </section>
                    <section class="col-xl-12 px-2 content-form-lista">
                        <div *ngFor="let itemFile of formData.get('otherFiles.file')?.value; let i = index">
                            <div class="lista-row mx-1" [@fadeIn]>
                                <span>
                                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                </span>
                                <div class="lista-actions">
                                    <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                        (click)="removeFile('otherFiles',i)" [icon]="faSquareXmark"></fa-icon>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="mt-3" *ngIf="formData.get('refundTypeId')?.valid">
                    <h4>Informações Gerais</h4>
                    <section class="row px-2">
                        <div class="col-xl-10 col-md-12 col-sm-12 mt-2 px-1">
                            <label class="content__form__title__label">Observações</label>
                            <textarea class="form-control input-form" maxlength="600"
                                placeholder="Insira aqui toda e qualquer informação que achar relevanta" rows="5"
                                formControlName="comments">
                                </textarea>
                            <small>
                            </small>
                        </div>
                    </section>
                </div>
                <div class="form-check formulario__cancelamento__checkbox mt-2">
                    <input class="form-check-input" formControlName="acceptedTerms" id="exampleCheck1" type="checkbox">
                    <label class="form-check-label content_formulario__cancelamento__label" for="exampleCheck1">
                        Autorizo a Fundação Copel a realizar perícia, caso julgar necessário, e a creditar ao titular,
                        via análise de pagamento, o valor correspondente ao reembolso, nos termos dos regulamentos em
                        vigor. Assumo total responsabilidade sobre a veracidade do(s) documento(s) apresentado(s).
                    </label>
                </div>
            </section>
        </section>
        <div class="content-buttons"
            *ngIf="formData.get('refundTypeId')?.valid && this.formData.get('beneficiaryId')?.value">
            <button class="btn button-primary-outline col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1"
                (click)="cancelarFormulario()">
                <div class="d-flex">
                    <span>Cancelar</span>
                </div>
            </button>
            <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
                [disabled]="!formData.controls.acceptedTerms.value || loading">
                <div class="d-flex" *ngIf="loading; else showSpan">
                    <span class="spinner">
                    </span>
                    <span> Carregando</span>
                </div>
                <ng-template #showSpan>
                    <span>Solicitar</span>
                </ng-template>
            </button>
        </div>
    </form>
</main>